/**
 * Shared AudioContext.
 * Lazily created and resumed on first call — must be invoked from a user-
 * gesture handler at least once (iOS Safari requirement).
 */

let audioContext: AudioContext | null = null;

export async function getAudioContext(): Promise<AudioContext> {
  if (!audioContext) {
    audioContext = new AudioContext();
  }
  if (audioContext.state === 'suspended') {
    await audioContext.resume();
  }
  return audioContext;
}

/** For tests / fast-reload only. Do not call in production code. */
export function _resetAudioContextForTests(): void {
  audioContext = null;
}
